import React, { useState } from 'react';
import './BibleVerseCard.css';

const BibleVerseCard = ({ verse }) => {
  const [dismissed, setDismissed] = useState(false);
  
  if (!verse || dismissed) return null;

  return (
    <div className="bible-verse-card">
      <button 
        className="dismiss-btn"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
      >
        ×
      </button>
      <p className="verse-text-card">{verse.text}</p>
      <p className="verse-reference-card">— {verse.reference}</p>
    </div>
  );
};

export default BibleVerseCard;